/* ===========================================
   NATURECA — globals JS — PHASE 6I
   Saved at: 2026-04-28
   - Topbar scroll behavior (solid фон след 80vh скрол)
   - Mobile hamburger toggle (drawer open/close)
   - ESC key и backdrop click за затваряне на drawer-а
   - Product grid add-to-cart (cart counter update + button feedback)
   - Cart drawer (Phase 6I — slide-in from right, opens on cart icon click only)
   =========================================== */

(function() {
  'use strict';

  /* ---------- Topbar scroll handler ---------- */
  (function topbarScroll() {
    var topbar = document.getElementById('topbar');
    if (!topbar) return;

    var threshold = window.innerHeight * 0.8;

    function update() {
      if (window.scrollY > threshold) {
        topbar.classList.add('scrolled');
      } else {
        topbar.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function() {
      threshold = window.innerHeight * 0.8;
      update();
    }, { passive: true });

    update();
  })();

  /* ---------- Mobile hamburger / drawer toggle ---------- */
  (function mobileDrawer() {
    var hamburger = document.getElementById('hamburger');
    var drawer = document.getElementById('mobile-drawer');
    var backdrop = document.getElementById('mobile-backdrop');
    var topbar = document.getElementById('topbar');

    if (!hamburger || !drawer || !backdrop) return;

    function open() {
      hamburger.classList.add('open');
      drawer.classList.add('open');
      backdrop.classList.add('open');
      if (topbar) topbar.classList.add('drawer-open');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      hamburger.classList.remove('open');
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      if (topbar) topbar.classList.remove('drawer-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function toggle() {
      if (drawer.classList.contains('open')) {
        close();
      } else {
        open();
      }
    }

    hamburger.addEventListener('click', toggle);
    backdrop.addEventListener('click', close);

    drawer.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', close);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        close();
      }
    });
  })();

  /* ---------- Product grid add-to-cart (Phase 6F FINAL v3) ---------- */
  (function productGridAddToCart() {
    console.log('[Phase 6F FINAL v3] init');
    var sections = document.querySelectorAll('.natureca-product-grid');
    if (sections.length === 0) return;

    function updateCartCounters(itemCount) {
      var counters = document.querySelectorAll('.cart-count');
      console.log('[Phase 6F FINAL v3] updating', counters.length, 'cart counters to', itemCount);
      counters.forEach(function (el) {
        el.textContent = itemCount;
      });
    }

    sections.forEach(function (section) {
      section.querySelectorAll('.product-card').forEach(function (card) {
        var btnAdd = card.querySelector('.btn-add');
        if (!btnAdd) return;

        var sizeBtns = card.querySelectorAll('.size-btn');

        function getSelectedVariantId() {
          if (sizeBtns.length > 0) {
            var active = card.querySelector('.size-btn.active');
            if (active) return active.getAttribute('data-variant-id');
            return sizeBtns[0].getAttribute('data-variant-id');
          }
          return btnAdd.getAttribute('data-default-variant-id');
        }

        function setLoadingState() {
          btnAdd.setAttribute('data-state', 'loading');
          btnAdd.setAttribute('disabled', '');
          var textEl = btnAdd.querySelector('.btn-add-text');
          if (textEl) {
            btnAdd.dataset.originalText = textEl.textContent;
            textEl.textContent = (window.NATURECA_I18N && window.NATURECA_I18N.adding) || 'Добавя…';
          }
        }

        function setSuccessState() {
          btnAdd.setAttribute('data-state', 'success');
          btnAdd.removeAttribute('disabled');
          var textEl = btnAdd.querySelector('.btn-add-text');
          if (textEl) textEl.textContent = (window.NATURECA_I18N && window.NATURECA_I18N.added) || '✓ Добавено';
          setTimeout(setIdleState, 2000);
        }

        function setIdleState() {
          btnAdd.removeAttribute('data-state');
          btnAdd.removeAttribute('disabled');
          var textEl = btnAdd.querySelector('.btn-add-text');
          if (textEl && btnAdd.dataset.originalText) {
            textEl.textContent = btnAdd.dataset.originalText;
            delete btnAdd.dataset.originalText;
          }
        }

        function setErrorState() {
          btnAdd.setAttribute('data-state', 'error');
          btnAdd.removeAttribute('disabled');
          var textEl = btnAdd.querySelector('.btn-add-text');
          if (textEl) textEl.textContent = (window.NATURECA_I18N && window.NATURECA_I18N.error) || 'Опитай отново';
          setTimeout(setIdleState, 3000);
        }

        btnAdd.addEventListener('click', function (e) {
          e.preventDefault();
          if (btnAdd.hasAttribute('disabled')) return;

          var variantId = getSelectedVariantId();
          if (!variantId) {
            setErrorState();
            return;
          }

          setLoadingState();

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }]
            })
          })
          .then(function (response) {
            if (!response.ok) throw new Error('cart/add failed: ' + response.status);
            return response.json();
          })
          .then(function () {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cartData) {
                updateCartCounters(cartData.item_count);
                setSuccessState();
              });
          })
          .catch(function (err) {
            console.error('[Phase 6F FINAL v3] Add to cart error:', err);
            setErrorState();
          });
        });
      });
    });
  })();

  /* ---------- Cart drawer (Phase 6I) ---------- */
  (function cartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var backdrop = document.getElementById('cart-drawer-backdrop');
    if (!drawer || !backdrop) return;

    var triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
    var closeBtn = drawer.querySelector('.cart-drawer-close');
    var loadingEl = drawer.querySelector('[data-cart-drawer-loading]');
    var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');

    function openDrawer() {
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function refreshCart() {
      showLoading();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function (err) {
          console.error('[Phase 6I] cart fetch error:', err);
        });
    }

    function showLoading() {
      loadingEl.hidden = false;
      emptyEl.hidden = true;
      itemsEl.hidden = true;
      footerEl.hidden = true;
    }

    function renderCart(cart) {
      countEl.textContent = cart.item_count;
      loadingEl.hidden = true;

      if (cart.item_count === 0) {
        emptyEl.hidden = false;
        itemsEl.hidden = true;
        footerEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      itemsEl.hidden = false;
      footerEl.hidden = false;

      itemsEl.innerHTML = cart.items.map(renderItem).join('');
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    function renderItem(item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_60x60$1$2')
        : '';
      var imgTag = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';
      var variantDisplay = (item.variant_title && item.variant_title !== 'Default Title')
        ? escapeHtml(item.variant_title) + ' · ' + formatMoney(item.price)
        : formatMoney(item.price);

      return '<li class="cart-drawer-item" data-line-key="' + escapeHtml(item.key) + '">' +
        '<div class="cart-drawer-item-image">' + imgTag + '</div>' +
        '<div class="cart-drawer-item-info">' +
          '<p class="cart-drawer-item-title">' +
            escapeHtml(item.product_title) +
          '</p>' +
          '<p class="cart-drawer-item-variant">' + variantDisplay + '</p>' +
          '<div class="cart-drawer-item-controls">' +
            '<button class="cart-drawer-qty-btn" data-action="decrease" aria-label="' + escapeHtml((window.NATURECA_I18N && window.NATURECA_I18N.decrease) || 'Намали') + '">−</button>' +
            '<span class="cart-drawer-qty-value">' + item.quantity + '</span>' +
            '<button class="cart-drawer-qty-btn" data-action="increase" aria-label="' + escapeHtml((window.NATURECA_I18N && window.NATURECA_I18N.increase) || 'Увеличи') + '">+</button>' +
            '<button class="cart-drawer-remove" data-action="remove">' + escapeHtml((window.NATURECA_I18N && window.NATURECA_I18N.remove) || 'Премахни') + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatMoney(cents) {
      var euros = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + euros;
    }

    function changeQuantity(lineKey, newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          updateGlobalCartCounters(cart.item_count);
        })
        .catch(function (err) {
          console.error('[Phase 6I] quantity change error:', err);
        });
    }

    function updateGlobalCartCounters(count) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        if (!drawer.contains(el)) el.textContent = count;
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var li = btn.closest('.cart-drawer-item');
      if (!li) return;
      var lineKey = li.getAttribute('data-line-key');
      var qtyEl = li.querySelector('.cart-drawer-qty-value');
      var currentQty = parseInt(qtyEl.textContent, 10);
      var action = btn.getAttribute('data-action');

      if (action === 'increase') changeQuantity(lineKey, currentQty + 1);
      else if (action === 'decrease') changeQuantity(lineKey, Math.max(0, currentQty - 1));
      else if (action === 'remove') changeQuantity(lineKey, 0);
    });

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

  // ===========================================
  // Phase 6P — GDPR consent checkbox validation за drawer
  // Event delegation на document — работи независимо от drawer state
  // ===========================================

  function handleDrawerCheckoutClick(e) {
    var checkoutBtn = e.target.closest('[data-cart-drawer-checkout]');
    if (!checkoutBtn) return;

    var consentBox = document.querySelector('[data-cart-drawer-consent]');
    var checkbox = document.querySelector('[data-cart-drawer-consent-checkbox]');
    var errorMsg = document.querySelector('[data-cart-drawer-consent-error]');

    // GDPR: ако consent markup съществува И не е отметнат → блокирай (Phase 6P, RULE 18).
    // stopImmediatePropagation + capture phase блокира Sendica's bubble handler.
    if (consentBox && checkbox && errorMsg && !checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      errorMsg.hidden = false;
      consentBox.classList.add('has-error');
      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { checkbox.focus(); }, 300);
      return;
    }

    // Sendica DE bypass: за държава на доставка ≠ BG → native Shopify checkout.
    // Заобикаля Sendica's Speedy custom checkout (който е само за BG).
    // stopImmediatePropagation блокира Sendica; navigate ръчно към localized /checkout.
    if (window.NATURECA_COUNTRY && window.NATURECA_COUNTRY !== 'BG') {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      window.location.href = checkoutBtn.getAttribute('href');
      return;
    }
    // BG → нищо: Sendica поема Speedy pickup flow-а както досега.
  }

  function handleDrawerCheckboxChange(e) {
    if (!e.target.matches('[data-cart-drawer-consent-checkbox]')) return;
    var consentBox = document.querySelector('[data-cart-drawer-consent]');
    var errorMsg = document.querySelector('[data-cart-drawer-consent-error]');
    if (e.target.checked) {
      if (errorMsg) errorMsg.hidden = true;
      if (consentBox) consentBox.classList.remove('has-error');
    }
  }

  // Capture phase (true) — runs ПРЕДИ Sendica's click handler
  document.addEventListener('click', handleDrawerCheckoutClick, true);
  document.addEventListener('change', handleDrawerCheckboxChange);
  })();

  /* Phase 6J — Custom natureca cart page interactivity */
  (function cartPage() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return; // not on cart page, abort

    const itemsContainer = page.querySelector('[data-cart-items]');
    const layoutEl = page.querySelector('[data-cart-content]');
    const emptyEl = page.querySelector('[data-cart-empty]');
    const subtotalEl = page.querySelector('[data-cart-subtotal]');
    const cartCountEl = page.querySelector('[data-cart-count]');

    if (!itemsContainer) return;

    // Helpers (duplicated from cartDrawer Phase 6I — kept local for safety) ----

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const parts = value.split('.');
      return '€' + parts[0] + ',' + parts[1];
    }

    function updateGlobalCartCounters(count) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = String(count);
      });
    }

    // Cart change call -------------------------------------------------------

    function changeQuantity(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .catch(function (err) {
          console.error('[cartPage] /cart/change.js failed', err);
          return null;
        });
    }

    // DOM updates -----------------------------------------------------------

    function updateLineSubtotal(itemEl, finalLinePriceCents) {
      const sub = itemEl.querySelector('[data-cart-line-subtotal]');
      if (sub) sub.textContent = formatMoney(finalLinePriceCents);
    }

    function updateLineQty(itemEl, qty) {
      const qtyEl = itemEl.querySelector('[data-cart-qty]');
      if (qtyEl) qtyEl.textContent = String(qty);
    }

    function updatePageTotals(cart) {
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (cartCountEl) cartCountEl.textContent = String(cart.item_count);
      updateGlobalCartCounters(cart.item_count);
    }

    function showEmptyState() {
      if (layoutEl) layoutEl.setAttribute('hidden', '');
      if (emptyEl) emptyEl.removeAttribute('hidden');
    }

    function removeItemFromDom(itemEl) {
      if (itemEl && itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);
    }

    // Re-index data-cart-line attributes after a removal so subsequent calls
    // to /cart/change.js use the correct line numbers.
    function reindexLines() {
      const items = itemsContainer.querySelectorAll('.cart-item');
      items.forEach(function (el, idx) {
        const newLine = String(idx + 1);
        el.setAttribute('data-cart-line', newLine);
        el.querySelectorAll('[data-cart-line]').forEach(function (btn) {
          btn.setAttribute('data-cart-line', newLine);
        });
      });
    }

    // Click handler ---------------------------------------------------------

    itemsContainer.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cart-action]');
      if (!btn) return;
      e.preventDefault();

      const action = btn.getAttribute('data-cart-action');
      const itemEl = btn.closest('.cart-item');
      if (!itemEl) return;

      const line = parseInt(itemEl.getAttribute('data-cart-line'), 10);
      if (!line) return;

      const currentQtyEl = itemEl.querySelector('[data-cart-qty]');
      const currentQty = currentQtyEl ? parseInt(currentQtyEl.textContent, 10) || 0 : 0;

      let newQty;
      if (action === 'increase') newQty = currentQty + 1;
      else if (action === 'decrease') newQty = Math.max(0, currentQty - 1);
      else if (action === 'remove') newQty = 0;
      else return;

      // Disable buttons during request to prevent double-click race
      const allBtns = itemEl.querySelectorAll('[data-cart-action]');
      allBtns.forEach(function (b) { b.disabled = true; });

      changeQuantity(line, newQty).then(function (cart) {
        if (!cart) {
          // Network error — re-enable buttons, no DOM changes
          allBtns.forEach(function (b) { b.disabled = false; });
          return;
        }

        if (newQty === 0) {
          removeItemFromDom(itemEl);
          reindexLines();
          if (cart.item_count === 0) {
            showEmptyState();
          }
        } else {
          // Re-enable buttons
          allBtns.forEach(function (b) { b.disabled = false; });

          // Update qty display
          updateLineQty(itemEl, newQty);

          // Update line subtotal — find the matching item in the response
          const matched = cart.items[line - 1];
          if (matched) {
            updateLineSubtotal(itemEl, matched.final_line_price);
          }
        }

        updatePageTotals(cart);
      });
    });

  // ===========================================
  // Phase 6P — GDPR consent checkbox validation за cart page
  // ===========================================

  function handleCartPageCheckoutClick(e) {
    var checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (!checkoutBtn) return;

    var consentBox = document.querySelector('[data-cart-consent]');
    var checkbox = document.querySelector('[data-cart-consent-checkbox]');
    var errorMsg = document.querySelector('[data-cart-consent-error]');

    // GDPR: ако consent markup съществува И не е отметнат → блокирай (Phase 6P, RULE 18).
    if (consentBox && checkbox && errorMsg && !checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      errorMsg.hidden = false;
      consentBox.classList.add('has-error');
      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { checkbox.focus(); }, 300);
      return;
    }

    // Sendica DE bypass: за държава на доставка ≠ BG → native Shopify checkout.
    if (window.NATURECA_COUNTRY && window.NATURECA_COUNTRY !== 'BG') {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      window.location.href = checkoutBtn.getAttribute('href');
      return;
    }
    // BG → нищо: Sendica поема Speedy pickup flow-а както досега.
  }

  function handleCartPageCheckboxChange(e) {
    if (!e.target.matches('[data-cart-consent-checkbox]')) return;
    var consentBox = document.querySelector('[data-cart-consent]');
    var errorMsg = document.querySelector('[data-cart-consent-error]');
    if (e.target.checked) {
      if (errorMsg) errorMsg.hidden = true;
      if (consentBox) consentBox.classList.remove('has-error');
    }
  }

  // Capture phase (true) — runs ПРЕДИ Sendica's click handler
  document.addEventListener('click', handleCartPageCheckoutClick, true);
  document.addEventListener('change', handleCartPageCheckboxChange);
  })();

  // ============================================================
  // Phase 6L — Product Image Lightbox
  // Click on .product-image opens overlay with all product.images
  // Wrap-around navigation, swipe support on mobile, ESC + arrows
  // ============================================================
  (function productLightbox() {
    var lightbox = document.querySelector('[data-product-lightbox]');
    if (!lightbox) return;

    var imageEl = lightbox.querySelector('[data-lb-image]');
    var counterEl = lightbox.querySelector('[data-lb-counter]');
    var thumbsEl = lightbox.querySelector('[data-lb-thumbs]');
    var prevBtn = lightbox.querySelector('[data-lb-prev]');
    var nextBtn = lightbox.querySelector('[data-lb-next]');
    var imageWrap = lightbox.querySelector('[data-lb-image-wrap]');
    var closeEls = lightbox.querySelectorAll('[data-lightbox-close]');

    var state = {
      images: [],
      index: 0,
      lastTrigger: null
    };

    function openLightbox(images, startIndex, triggerEl) {
      if (!images || images.length === 0) return;
      state.images = images;
      state.index = Math.max(0, Math.min(startIndex || 0, images.length - 1));
      state.lastTrigger = triggerEl || null;

      renderThumbnails();
      renderImage();
      updateNavVisibility();

      lightbox.removeAttribute('hidden');
      requestAnimationFrame(function () {
        lightbox.setAttribute('data-active', '');
        document.body.classList.add('lb-open');
      });
    }

    function closeLightbox() {
      lightbox.removeAttribute('data-active');
      setTimeout(function () {
        lightbox.setAttribute('hidden', '');
        document.body.classList.remove('lb-open');
        if (state.lastTrigger) {
          state.lastTrigger.focus();
        }
      }, 250);
    }

    function goToImage(newIndex) {
      var len = state.images.length;
      if (len === 0) return;
      state.index = ((newIndex % len) + len) % len;
      renderImage();
      updateThumbnailActive();
    }

    function next() { goToImage(state.index + 1); }
    function prev() { goToImage(state.index - 1); }

    function renderImage() {
      var img = state.images[state.index];
      if (!img) return;
      imageEl.setAttribute('data-loading', '');
      var tempImg = new Image();
      tempImg.onload = function () {
        imageEl.src = img.src;
        imageEl.alt = img.alt || '';
        imageEl.removeAttribute('data-loading');
      };
      tempImg.onerror = function () {
        imageEl.src = img.src;
        imageEl.alt = img.alt || '';
        imageEl.removeAttribute('data-loading');
      };
      tempImg.src = img.src;
      counterEl.textContent = (state.index + 1) + ' / ' + state.images.length;
    }

    function renderThumbnails() {
      thumbsEl.innerHTML = '';
      state.images.forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.className = 'lb-thumb';
        btn.type = 'button';
        btn.setAttribute('aria-label', ((window.NATURECA_I18N && window.NATURECA_I18N.photo) || 'Снимка') + ' ' + (i + 1));
        btn.setAttribute('data-thumb-index', String(i));
        if (i === state.index) {
          btn.setAttribute('aria-current', 'true');
        }
        var thumbImg = document.createElement('img');
        thumbImg.src = img.src;
        thumbImg.alt = '';
        thumbImg.loading = 'lazy';
        btn.appendChild(thumbImg);
        btn.addEventListener('click', function () {
          goToImage(i);
        });
        thumbsEl.appendChild(btn);
      });
    }

    function updateThumbnailActive() {
      var thumbs = thumbsEl.querySelectorAll('.lb-thumb');
      thumbs.forEach(function (thumb, i) {
        if (i === state.index) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function updateNavVisibility() {
      var single = state.images.length <= 1;
      if (single) {
        prevBtn.setAttribute('hidden', '');
        nextBtn.setAttribute('hidden', '');
        thumbsEl.style.display = 'none';
      } else {
        prevBtn.removeAttribute('hidden');
        nextBtn.removeAttribute('hidden');
        thumbsEl.style.display = '';
      }
    }

    // Click triggers from product cards
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-product-card-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var imagesAttr = trigger.getAttribute('data-images');
      if (!imagesAttr) return;
      try {
        var images = JSON.parse(imagesAttr);
        if (images && images.length > 0) {
          openLightbox(images, 0, trigger);
        }
      } catch (err) {
        console.warn('[Phase 6L] Failed to parse data-images:', err);
      }
    });

    // Close handlers
    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeLightbox();
      });
    });

    // Prev/Next buttons
    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (lightbox.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        prev();
      } else if (e.key === 'ArrowRight') {
        next();
      } else if (e.key === 'Home') {
        goToImage(0);
      } else if (e.key === 'End') {
        goToImage(state.images.length - 1);
      }
    });

    // Touch swipe (mobile)
    var touchStartX = null;
    var touchStartY = null;
    var swipeThreshold = 50;

    imageWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    imageWrap.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var diffX = endX - touchStartX;
      var diffY = endY - touchStartY;

      // Only trigger if horizontal swipe is dominant (avoid scroll conflict)
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > swipeThreshold) {
        if (diffX > 0) {
          prev();
        } else {
          next();
        }
      }
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
  })();

})();
